export default __webpack_public_path__ + "static/media/offer7.d21b97c1.jpg";